
export default {
  inject: ['wizard'],

  created() {
    if (!this.wizard) {
      throw new Error('WizardChild must be a descendant of a Wizard')
    }
  },
}
